var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.debtAmount > 0)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('AppChip',_vm._g(_vm._b({attrs:{"color":"#cc5500","text-color":"white--text","data-test":"debtBadge"}},'AppChip',attrs,false),on),[_vm._v(_vm._s(_vm.$t("organisations:organisationProfile.debts.badge", "Debts")))])]}}],null,false,2144290590)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(
      [
        "organisations:organisationProfile.debts.tooltip",
        "Details: {\{debtToFederationAmount}\} to Federation; {\{debtToTopRegionOrganisationAmount}\} to League"
      ],
      {
        debtToFederationAmount: _vm.masterCurrency(
          _vm.organisation.debtToFederationCents
        ),
        debtToTopRegionOrganisationAmount: _vm.masterCurrency(
          _vm.organisation.debtToTopRegionOrganisationCents
        ),
        interpolation: { escapeValue: false }
      }
    )))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }